import React from 'react';

/**
 * The two extra figures the wallet ledger provides, shown under a balance.
 *
 * `balance` stays what it has always been: money that can be spent now. These
 * lines explain the parts of it that behave differently —
 *   pending: credited, spendable, but the money has not reached the pool
 *            account yet, so it cannot be cashed out;
 *   on hold: reserved for a payment that is still going through.
 *
 * Nothing renders when the wallet has neither, or when the backend predates
 * the ledger and sends neither field.
 */
export default function BalanceBreakdown({ wallet, tone = 'light', className = '' }) {
  const pending = Number(wallet?.pending_balance || 0);
  const onHold = Number(wallet?.on_hold || 0);
  if (!pending && !onHold) return null;

  const muted = tone === 'dark' ? 'text-white/70' : 'text-[#1B0C34]/60';
  const strong = tone === 'dark' ? 'text-white' : 'text-[#1B0C34]';
  const rand = (v) => `R ${Number(v).toFixed(2)}`;

  return (
    <div className={`mt-2 space-y-0.5 text-xs ${muted} ${className}`} data-testid="balance-breakdown">
      {pending > 0 && (
        <p data-testid="balance-pending">
          <span className={`font-semibold ${strong}`}>{rand(pending)}</span> still clearing
          {' '}— you can spend it now, and withdraw it once it settles
        </p>
      )}
      {onHold > 0 && (
        <p data-testid="balance-on-hold">
          <span className={`font-semibold ${strong}`}>{rand(onHold)}</span> reserved for a payment in progress
        </p>
      )}
      {wallet?.withdrawable_balance != null && pending > 0 && (
        <p data-testid="balance-withdrawable">
          <span className={`font-semibold ${strong}`}>{rand(wallet.withdrawable_balance)}</span> available to cash out
        </p>
      )}
    </div>
  );
}
